import {MediaPlayback} from '../../../model/SessionState';
import {logUtishaDebug} from 'src/app/util/log';
import {HTMLVideoElementCanvasRenderer} from './HTMLVideoElementCanvasRenderer';

/**
 * Renderer for drawing MediaPlayback on a canvas
 * Extends HTMLVideoElementCanvasRenderer since both use an HTMLVideoElement
 */
export class MediaPlaybackCanvasRenderer extends HTMLVideoElementCanvasRenderer {

  /**
   * Creates a new MediaPlaybackCanvasRenderer
   * @param mediaPlayback MediaPlayback to render
   * @param _priority Drawing priority (higher means drawn later/on top)
   */
  constructor(
    mediaPlayback: MediaPlayback,
    _priority = 10
  ) {
    if (!mediaPlayback.file) {
      throw new Error('MediaPlaybackCanvasRenderer: mediaPlayback.file is required');
    }
    if (!mediaPlayback.title) {
      mediaPlayback.title = 'Media';
    }
    // Create a video element for the media playback
    const videoElement = document.createElement('video');
    videoElement.muted = true;
    videoElement.crossOrigin = 'anonymous';
    videoElement.src = mediaPlayback.file.url;
    videoElement.loop = !!mediaPlayback.file.loop;

    // Start playing
    videoElement.play().catch(error => {
      logUtishaDebug(`MediaPlaybackCanvasRenderer[${this.id}]: error playing media - ${error}`);
    });

    super(videoElement, _priority);
  }

  /**
   * Gets the name of this renderer
   */
  /**
   * Gets the name of this renderer
   */
  get name(): string {
    return MediaPlaybackCanvasRenderer.NAME;
  }

  static get NAME() {
    return 'MediaPlaybackCanvasRenderer';
  }

  /**
   * Destroys the renderer and cleans up resources
   */
  destroy(): void {
    if (this.videoElement) {
      this.videoElement.pause();
      this.videoElement.src = '';
    }

    super.destroy();
  }
}
